// extracted by mini-css-extract-plugin
export default {"invitedCard":"style_invitedCard__JoxZh","footer":"style_footer__m6tN1","resend":"style_resend__EhfZ3"};